import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("mechanization") !== null && localStorage.getItem("mechanization") !== undefined && localStorage.getItem("mechanization") !== "") {

    data = JSON.parse(localStorage.getItem("mechanization"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getmechanization: (state, action) => {
            // localStorage.setItem("mechanization", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getmechanization } = Insider.actions;
export default Insider.reducer;